import { Editor } from "grapesjs";
import { useParams } from "react-router";
import APIS from "../constant/Endpoint";
import { useModalEditor } from "../context/GrapejsModalContext";
import { postApiFormData } from "../helpers/AxiosInstance";
import { convertGrapeJSToDjangoTemlate } from "../utils/grapejs";
import usePatchHook from "./usePatchHook";

const useModalEditorHook = () => {
  let { id } = useParams();

  const { mutateAsync: modalUpdate } = usePatchHook({
    queryKey: [`popup-${id}`],
    navigateURL: "",
  });
  const { editor: modalEditor } = useModalEditor();

  const handleDeviceChange = (deviceId: string | undefined) => {
    if (!deviceId) return;
    modalEditor?.Devices.select(deviceId);
  };

  const handleMediaUpload = async (file, editor: Editor) => {
    const url = APIS.FILE;
    const formData = new FormData();
    formData.append("file", file[0]);
    formData.append("object_id", id);
    formData.append("folder", "page-builder");
    try {
      const res = await postApiFormData({ url, formData });
      if (res.status === 201) {
        const fileUrl = res?.data?.file;
        if (editor?.AssetManager) {
          editor.AssetManager.add({ src: fileUrl });
          const selected = editor.getSelected();
          if (selected && selected.is("image")) {
            selected.set("src", fileUrl);
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handlePanelChange = async (panelId: string) => {
    // const panelManager = editor.Panels;

    switch (panelId) {
      case "save":
        const pageURL = `${APIS.POPUP}${id}/`;
        await modalUpdate({
          url: pageURL,
          formData: {
            css_content: modalEditor.getCss(),
            html_content: await convertGrapeJSToDjangoTemlate(
              modalEditor.getHtml()
            ),
            json_content: modalEditor.Blocks.getAllMap(),
            project_data: modalEditor.getProjectData(),
          },
        }),
          modalEditor.getModel().set("changesCount", 0);
        break;
      case "undo":
        modalEditor?.UndoManager.undo();
        break;
      case "redo":
        modalEditor?.UndoManager.redo();

        break;
      case "trash":
        modalEditor?.DomComponents.clear();
        modalEditor?.CssComposer.clear();
        break;
      case "visibility":
        window.open(`https://builder.careinfosolutions.com/`, "_blank");
        break;
      case "fullscreen":
        modalEditor?.Commands.run("fullscreen");
        break;
      case "setting":
        modalEditor?.Commands.run("setting-popup");
        break;
      case "seo":
        modalEditor?.Commands.run("seo-popup");
        break;
      case "export":
        modalEditor?.Commands.run("export-template");
        break;
      case "delete":
        modalUpdate({
          url: `${APIS.POPUP}${id}/`,
          formData: {
            css_content: "",
            html_content: "",
            json_content: "",
            project_data: "",
          },
        });
        break;
      case "outline":
        modalEditor?.Commands.isActive("core:component-outline")
          ? modalEditor?.Commands.stop("core:component-outline")
          : modalEditor?.Commands.run("core:component-outline");
        break;
      default:
        break;
    }
  };

  return { handleDeviceChange, handlePanelChange, handleMediaUpload };
};

export default useModalEditorHook;
